import { Link } from "@reach/router";

import styled from "../../styled-components";

export const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.blue};
`;
